import {
  LOAD_INVOICE_ITEMS,
  CLOSE_LOAD_INVOICE_ITEMS,
  LOAD_EXPENSE_ITEMS,
  CLOSE_LOAD_EXPENSE_ITEMS,
  LOAD_SALARY_ITEMS,
  CLOSE_LOAD_SALARY_ITEMS,
  ADMIN_SEND_NEW_INVOICE_SUCCESS,
  ADMIN_GENERATE_PDF_SUCCESS,
  ADMIN_GENERATE_PDF_FAILED,
  LOAD_SIGN_SEND,
  CLOSE_LOAD_SIGN_SEND
} from '../constants'

const loaderReducer = (
  state = {
    showInvoiceItemLoader: false,
    showExpenseItemLoader: false,
    showSalaryItemLoader: false,
    showPartialInvoiceLoader: false,
    showSignSendLoader: false
  },
  action
) => {
  switch (action.type) {
    case LOAD_INVOICE_ITEMS:
      return Object.assign({}, { ...state }, { showInvoiceItemLoader: true })

    case CLOSE_LOAD_INVOICE_ITEMS:
      return Object.assign({}, { ...state }, { showInvoiceItemLoader: false })

    case LOAD_EXPENSE_ITEMS:
      return Object.assign({}, { ...state }, { showExpenseItemLoader: true })

    case CLOSE_LOAD_EXPENSE_ITEMS:
      return Object.assign({}, { ...state }, { showExpenseItemLoader: false })

    case LOAD_SALARY_ITEMS:
      return Object.assign({}, { ...state }, { showSalaryItemLoader: true })

    case CLOSE_LOAD_SALARY_ITEMS:
      return Object.assign({}, { ...state }, { showSalaryItemLoader: false })

    case ADMIN_SEND_NEW_INVOICE_SUCCESS:
      return Object.assign({}, { ...state }, { showPartialInvoiceLoader: true })

    case ADMIN_GENERATE_PDF_SUCCESS:
    case ADMIN_GENERATE_PDF_FAILED:
      return Object.assign(
        {},
        { ...state },
        { showPartialInvoiceLoader: false }
      )

    case LOAD_SIGN_SEND:
      return Object.assign(
        {},
        { ...state },
        {
          showSignSendLoader: true
        }
      )
    case CLOSE_LOAD_SIGN_SEND:
      return Object.assign(
        {},
        { ...state },
        {
          showSignSendLoader: false
        }
      )

    default:
      return state
  }
}

export default loaderReducer
